import { BaseEntity, JsonApiResource } from '../jsonapi-provider';

@JsonApiResource({
  type: 'meals-for-day',
})
export default class MealsForDay extends BaseEntity {
  scheduleId: string = '';

  name: string = '';
  mealId: number = 1;
  mealType: string = '';
  validCode: string = '';
  description: string = '';
}
